// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__1WrTx","sidebar__paper":"Sidebar_sidebar__paper__-ER3R","sidebar__header":"Sidebar_sidebar__header__2lLyd"};